﻿import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { MenuItem } from "@blueprintjs/core";
import { useNavigate } from "react-router-dom";
import 'components/navigation/Navigation.css';


export function InternalMenuItem(
    {
        id = null,
        forceRedirect = false,
        menuItemType = 'li',
        className,
        location,
        nodeType,
        text
    }
) {

    var navigate = useNavigate();

    const dispatch = useDispatch();
    const preventSwitch = useSelector(state => state.dirtyData.dirty);

    function navigateToInternalLocation() {

        if (forceRedirect) {

            if (preventSwitch === true) {
                dispatch({ type: 'BEGIN_REDIRECT', payload: simpleRedirect });
                return;
            } else {
                simpleRedirect()
            }
            
        } else {
            navigate(location);
        }

    }

    function simpleRedirect() {
        window.location = location;
    }

    return (nodeType === "a" ? (<a className={className} id={id} onClick={navigateToInternalLocation} onKeyDown={(e) => { }}>{text}</a>) : (<MenuItem className={className} id={id} text={text} onClick={navigateToInternalLocation} />));
}


InternalMenuItem.propTypes = {
    id: PropTypes.string,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    location: PropTypes.string.isRequired,
    forceRedirect: PropTypes.bool,
    nodeType: PropTypes.string,
    className: PropTypes.string
};